import React, {useCallback, useRef} from 'react';

import styles from './OfferPopupInfo.module.scss';

import {FREE_TEXT, TAX_INCLUDED_TEXT} from "../../shared/constants";
import LoadableImage from "../LoadableImage/LoadableImage";
import useClickOutside from "../../hooks/useClickOutside";

const OfferPopupInfo = ({ info, selectOfferById, closeOfferPopupInfo }) => {
    const isFirstRender = useRef(true);

    const wrapperRef = useClickOutside(useCallback(() => {
        if (!isFirstRender.current) {
            closeOfferPopupInfo();
        } else {
            isFirstRender.current = false;
        }
    }, [closeOfferPopupInfo]));

    const goToPurchaseOffer = () => {
        closeOfferPopupInfo();
        selectOfferById(info.id, info.categoryId);
    }

    return (
        <div className={styles.overlay}>
            <div className={`${styles.wrapper} ${info.isClaimed ? styles.claimed : null}`} ref={wrapperRef}>
                <LoadableImage img={info.img} />
                <div className={styles.offerLayoutPrice} onClick={goToPurchaseOffer}>
                    <div className={styles.offerPrice}>{info.isFree ? FREE_TEXT : null}</div>
                </div>
                <div className={styles.buttonClose} onClick={() => closeOfferPopupInfo()} />
            </div>
        </div>
    );
};

export default OfferPopupInfo;